import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResearchAuthGuard } from 'research.oidc.angular';
import { ReportingPageComponent } from './reporting-page/reporting-page.component';
import { ReportingFilterOptionsResolver } from './resolvers/reporting-filter-options.resolver';

const routes: Routes = [
  {
    path: 'reporting',
    component: ReportingPageComponent,
    canActivate: [ResearchAuthGuard],
    resolve: {
      filterOptions: ReportingFilterOptionsResolver
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportingRoutingModule { }



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/reporting/reporting-routing.module.ts